import { render, staticRenderFns } from "./CaseDetailBase.vue?vue&type=template&id=19c8e282&scoped=true"
import script from "./CaseDetailBase.vue?vue&type=script&lang=js"
export * from "./CaseDetailBase.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailBase.vue?vue&type=style&index=0&id=19c8e282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8e282",
  null
  
)

export default component.exports